<template>
  <v-select
    auto-select-first
    clearable
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    :return-object="false"
    dense
    x-small
    @change="onChange($event)"    
    hide-details
    v-bind="resetProps"
  />
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: [String, Object],
    hideDetails: Boolean,
    dense: Boolean,
  },
  data() {
    return {
      innerValue: this.value,
    };
  },


  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
    onChange() {
      this.$emit("onChange");
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    resetProps() {
      return { ...this.$attrs };
    },
    options() {
      return [
        {
          value: "Labor",
          text: `Labor`,
        },
        {
          value: "Parts",
          text: `Parts`,
        },
      ];
    },
  },
};
</script>